/**
 * Objeto padrão para criar uma flutuação
 * @returns {Object}
 */
export const defaultObjStructure = () => {
  return {
    codigoHotel: 0,
    nome: null,
    tipoFlutuacao: 0,
    prioritaria: false,
    ativo: true,
    codigoPMS: null,
    exibeDesconto: true,
    idiomas: [
      {
        idioma: 'es-ES',
        nome: '',
        politica: '',
        pensao: ''
      },
      {
        idioma: 'en-US',
        nome: '',
        politica: '',
        pensao: ''
      },
      {
        idioma: 'pt-BR',
        nome: '',
        politica: '',
        pensao: ''
      }
    ],
    tipoCoeficiente: 0,
    coeficiente: 100,
    codigoTarifaBase: null,
    utilizaNoitesGratis: false,
    tipoNoitesGratis: 1,
    diariasNoitesGratis: null,
    quantidadeNoitesGratis: null,
    coeficienteDiasSemana: [],
    diferenciaisQuartos: [],
    diferenciaisPax: [],
    pensoes: [],
    precosQuartos: [],
    meiosPagamento: [],
    percentualOcupacaoMinimo: null,
    percentualOcupacaoMaximo: null,
    minimoNoitesDe: null,
    minimoNoitesAte: null,
    antecedenciaDe: null,
    antecedenciaAte: null,
    dataInicioReserva: null,
    dataFimReserva: null,
    horaInicioReserva: '00:00',
    horaFimReserva: '23:59',
    dataPernoiteObrigatorio: null,
    checkinSegunda: false,
    checkinTerca: false,
    checkinQuarta: false,
    checkinQuinta: false,
    checkinSexta: false,
    checkinSabado: false,
    checkinDomingo: false,
    lastMinute: null,
    lastMinuteDescricao: null,
    minimoAdultos: null,
    minimoCriancas: null,
    maximoAdultos: null,
    maximoCriancas: null,
    linkPublico: '',
    periodosHospedagem: [],
    periodosBlackout: [],
    quartos: [],
    devices: [],
    gruposCrm: [],
    promocodes: [],
    tarifasCorporativas: [],
    corporativeRates: [],
    allotmentQuartos: [],
    checkinFlexivel: false,
    coeficienteCheckin: null,
    diasToleranciaCheckin: null,
    checkoutFlexivel: false,
    coeficienteCheckout: null,
    diasToleranciaCheckout: null,
    formasPagamentoExclusivoFlutuacao: false,
    somentePix: false,
    habilitarPagamentoPix: false,
    somenteBoleto: false,
    habilitarPagamentoBoleto: false,
    formasPagamento: [],
    promocao: false,
    urlImagemPromocional: null,
    nomePromocional: null,
    urlPromocao: null,
    destaques: [],
    dataInicioPeriodoDestaque: null,
    dataFimPeriodoDestaque: null,
    pacoteFechado: false
  }
}
